import { Space, Typography } from "@payping/web-components";
import React from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";
import LoginEnableDisable from "@/pages/Profile/2fa/LoginEnableDisable";
import CashEnableDisable from "@/pages/Profile/2fa/CashEnableDisable";

const TwoFASection: React.FC = () => {
  const { t } = useAppTranslation();

  return (
    <>
      <Typography.Title level={4} className={"tw-font-medium"}>
        {t("profile.twoStepPassword")}
      </Typography.Title>
      <Space direction={"vertical"} size={"middle"} className={"tw-w-full"}>
        <LoginEnableDisable />
        <CashEnableDisable />
      </Space>
    </>
  );
};

export default TwoFASection;
